import styled from 'styled-components';

export const DetailsLogo = styled.div`
  width: 140px;
  min-height: ${({ theme }) => theme.x12spacePx}px;
  margin-bottom: ${(props) => props.theme.x3space}rem;
  padding: 16px;
  text-align: center;
`;

export const DetailsSummary = styled.ul`
  li {
    margin-top: ${(props) => props.theme.x1space}rem;
    &:first-child {
      margin-top: 0;
    }
    > span {
      font-weight: bold;
    }
  }
`;
